import React from 'react';

function ProfilePage () {
    return <div>
        Profile Page
    </div>
}

export default ProfilePage;